//*************************** New Product details *****************

(function($) {
    class slider {
        slider;
        outer;
        inner;
        prv;
        nxt;
        duration = 300;
        moving;
        options = {
            duration: 300,
            gap: 0,
            noscrollAlign: 'top'
        };
        lastWindiwSize;
        constructor(ele, _options) {
            this.slider = $(ele);
            this.outer = this.slider.find('.jq__slider__outer');
            this.inner = this.slider.find('.jq__slider__inner');
            this.prv = this.slider.find('.slider__prv');
            this.nxt = this.slider.find('.slider__nxt');
            this.options = $.extend({}, this.options, _options);
            this.options.duration = this.slider.data('duration') || this.options.duration;
            this.initOrientation = this.isVerticalSlider() ? 'vertical' : 'horizontal';
            this.resizeDelay = this.setDelayFunction();
            this.nextClickDelay = this.setDelayFunction();

            this.setItemWidth(true);
            this.nxt.on("touchend click", ()=> {
              this.nextClickDelay(()=> {
                if(this.moving) return;
                if(this.isVerticalSlider()) {
                    this.goBottom();
                }
                else {
                    this.goNext();
                }
              }, 100);
            });
            this.prv.on("touchend click", ()=> {
              this.nextClickDelay(()=> {
                if(this.moving) return;
                if(this.isVerticalSlider()) {
                    this.goTop();
                }
                else {
                    this.goPrev();
                }
              }, 100);
            });

            this.inner.on('click', '.item__outer', (event)=> {
                this.inner.find('.item__outer').removeClass('_focus');
                $(event.currentTarget).addClass('_focus');
                let index = $(event.currentTarget).data("index") ?? $(event.currentTarget).index();
                this.options.itemClick && this.options.itemClick($(event.currentTarget), index);
            });

            this.inner.css({
                'top': 0,
                'left': 0
            });

            if(!this.slider.hasClass('vertical__scroll')) {
                this.slider.addClass('horizontal__scroll');
            }

            this.slider.on('goTo', (e, index, focus)=> {
                this.goTo(index, focus);
            });

            $(window).resize(()=> {
              this.resizeDelay(()=> {
                this.isWindowResized(()=> {
                  this.setItemWidth();
                });
              }, 100);
            });
        }

        isWindowResized(callback) {
          if(this.lastWindiwSize !== window.innerWidth) {
            this.lastWindiwSize = window.innerWidth;
            callback();
          }
        }

        getLastScroll() {
            let lastScroll = this.inner[0].style.left;

            if(this.isVerticalSlider()) {
                lastScroll = this.inner[0].style.top;
            }

            lastScroll = Math.abs(Number(lastScroll.replace(/[a-z]+/g,'')) || 0);
            return lastScroll;
        }

        goHorizontal(next, focusClass) {
            let index = next.data("index") ?? next.index();
            if(next.hasClass('_active')) {
                if(focusClass) {
                    this.inner.find('.item__outer').removeClass('_focus');
                    next.addClass('_focus');
                }
                this.options.beforeChange && this.options.beforeChange(next, index);
                this.options.afterChange && this.options.afterChange(next, index);
                return;
            }

            if(next.length) {
                let nextData = this.elementData(next[0]);
                let outerData = this.elementData(this.outer[0]);
                let lastScroll = this.getLastScroll();
                let move = (nextData.right - outerData.right) + lastScroll;

                if((outerData.left - nextData.left) >= 0) {
                    move = lastScroll - (outerData.left - nextData.left);
                }

                if(0 > move) {
                  move = 0;
                }

                this.options.beforeChange && this.options.beforeChange(next, index);
                this.scrollTo(move).then(()=> {
                    if(focusClass) {
                        this.inner.find('.item__outer').removeClass('_focus');
                        next.addClass('_focus');
                    }
                    this.options.afterChange && this.options.afterChange(next, index);
                });
            }
        }

        goNext() {
            let last = this.inner.find('.item__outer._active').last();
            let next = last.next();
            this.goHorizontal(next);
        }

        goPrev() {
            let first = this.inner.find('.item__outer._active').first();
            let prev = first.prev();
            this.goHorizontal(prev);
        }

        goVertical(next, focusClass) {
            let index = next.data("index") ?? next.index();
            if(next.hasClass('_active')) {
                if(focusClass) {
                    this.inner.find('.item__outer').removeClass('_focus');
                    next.addClass('_focus');
                }
                this.options.beforeChange && this.options.beforeChange(next, index);
                this.options.afterChange && this.options.afterChange(next, index);
                return;
            }

            if(next.length) {
                let nextData = this.elementData(next[0]);
                let outerData = this.elementData(this.outer[0]);
                let lastScroll = this.getLastScroll();
                let move = (nextData.bottom - outerData.bottom) + lastScroll;

                if((outerData.top - nextData.top) >= 0) {
                    move = lastScroll - (outerData.top - nextData.top);
                }

                this.options.beforeChange && this.options.beforeChange(next, index);
                this.scrollTo(move).then(()=> {
                    if(focusClass) {
                        this.inner.find('.item__outer').removeClass('_focus');
                        next.addClass('_focus');
                    }
                    this.options.afterChange && this.options.afterChange(next, index);
                });
            }
        }

        goBottom() {
            let last = this.inner.find('.item__outer._active').last();
            let next = last.next();
            this.goVertical(next);
        }

        goTop() {
            let first = this.inner.find('.item__outer._active').first();
            let prev = first.prev();
            this.goVertical(prev);
        }

        goTo(item_index, focusClass) {
            if(!this.slider.hasClass('jq__slider__init')) {
                setTimeout(()=> {
                    this.goTo(item_index, focusClass);
                }, 100);
                return;
            }

            let find_item = this.inner.find('.item__outer[data-index="' + item_index + '"]');
            let item = find_item.length ? find_item : this.inner.find('.item__outer').eq(item_index);
            if(!item.length) return;
            if(this.slider.hasClass('vertical__scroll')) {
                this.goVertical(item, focusClass);
            }
            else {
                this.goHorizontal(item, focusClass);
            }
        }

        scrollTo(scroll, animation) {
            let _time = animation === false ? 0 : (this.options.duration + 100);
            return new Promise((resolve)=> {
                let outerData = this.elementData(this.outer[0]);
                let innerData = this.elementData(this.inner[0]);
                let totalScroll;

                if(animation === false) {
                    this.inner.css({
                        'transition-duration': `0s`
                    });
                }
                else {
                    this.inner.css({
                        'transition-duration': `${(this.options.duration/1000).toFixed(2)}s`
                    });
                }

                this.moving = true;
                setTimeout(()=> {
                    this.nxt.removeClass('__no__scroll');
                    this.prv.removeClass('__no__scroll');
                    this.inner.css('top', 0);
                    this.inner.css('left', 0);

                    if(this.isVerticalSlider()) {
                        if(outerData.height >= innerData.height) {
                            if(this.options.noscrollAlign === "center") {
                                totalScroll = (outerData.height - innerData.height)/2;
                            }
                            else if(this.options.noscrollAlign === "bottom") {
                                totalScroll = outerData.height - innerData.height;
                            }
                            else {
                                totalScroll = 0;
                            }
                            
                            this.inner.css('top', totalScroll);
                            this.nxt.addClass('__no__scroll');
                            this.prv.addClass('__no__scroll');
                        }
                        else {
                            totalScroll = innerData.height - outerData.height;
                            if(totalScroll >= scroll) {
                                this.inner.css('top', -scroll);
                            }
                            else {
                                this.inner.css('top', -totalScroll);
                            }
                        }
                    }
                    else {
                        if(outerData.width >= innerData.width) {
                            if(this.options.noscrollAlign === "center") {
                                totalScroll = (outerData.width - innerData.width)/2;
                            }
                            else if(this.options.noscrollAlign === "right") {
                                totalScroll = outerData.width - innerData.width;
                            }
                            else {
                                totalScroll = 0;
                            }
                            
                            this.inner.css('left', totalScroll);
                            this.nxt.addClass('__no__scroll');
                            this.prv.addClass('__no__scroll');
                        }
                        else {
                            totalScroll = innerData.width - outerData.width;
                            if(totalScroll >= scroll) {
                                this.inner.css('left', -scroll);
                            }
                            else {
                                this.inner.css('left', -totalScroll);
                            }
                        }
                    }
                    
                    setTimeout(()=> {
                        this.addActiveClass();
                        this.moving = false;
                        resolve();
                    }, _time);
                }, 0);
            });
        }

        isVerticalSlider() {
            return this.slider.hasClass('vertical__scroll');
        }
        addActiveClass(init) {
            if(init) {
                this.inner.find('.item__outer').removeClass('_hide');
            }
            this.inner.find('.item__outer').removeClass('_active');
            this.inner.find('.item__outer').each((ind, ele)=> {
                if(this.isElementInView(ele)) {
                    $(ele).addClass('_active');
                }
            });

            let next = this.inner.find('.item__outer._active').last().next();
            let prev = this.inner.find('.item__outer._active').first().prev();

            this.prv.removeClass('_disable');
            this.nxt.removeClass('_disable');

            if(!next.length) {
                this.nxt.addClass('_disable');
            }

            if(!prev.length) {
                this.prv.addClass('_disable');
            }
        }

        getResponsiveItemsWidth() {
            let width = false;
            let responsiveItems = this.options.responsiveItems;

            if(responsiveItems) {
                let arr = Object.keys(responsiveItems);

                for (let i = arr.length-1; i > -1; i--) {
                    let _w = Number(arr[i]);
                    if(window.innerWidth >= _w) {
                        width = responsiveItems[_w];
                        break;
                    }
                }
            }

            return width;
        }

        getOptionOrientation() {
            let width = false;
            let responsiveOrientation = this.options.responsiveOrientation;

            if(responsiveOrientation) {
                let arr = Object.keys(responsiveOrientation);

                for (let i = arr.length-1; i > -1; i--) {
                    let _w = Number(arr[i]);
                    if(window.innerWidth >= _w) {
                        width = responsiveOrientation[_w];
                        break;
                    }
                }
            }

            return width;
        }

        setItemGap() {
            let gap = this.options.gap;

            if(gap) {
                let items = this.inner.find('.item__outer');
                for(let i=1; i<items.length; i++) {
                    if(this.isVerticalSlider()) {
                        items[i].style.marginLeft = '';
                        items[i].style.marginTop = gap + 'px';
                    }
                    else {
                        items[i].style.marginLeft = gap + 'px';
                        items[i].style.marginTop = '';
                    }
                }
                
                return gap;
            }
            else {
                let returnGap = 0;
                let item2 = this.inner.find('.item__outer').eq(1);
                if(item2.length) {
                    if(this.isVerticalSlider()) {
                        returnGap += this.getPropertyValue(item2[0], 'margin-top');
                        returnGap += this.getPropertyValue(item2[0], 'margin-bottom');
                    }
                    else {
                        returnGap += this.getPropertyValue(item2[0], 'margin-left');
                        returnGap += this.getPropertyValue(item2[0], 'margin-right');
                    }
                }
                return returnGap;
            }
        }

        setOrientation(init) {
            let orientation = this.getOptionOrientation();
            let lastScrollItem = this.inner.find('._focus');

            if(!lastScrollItem.length) {
                lastScrollItem = this.inner.find('._active');
            }

            if(!lastScrollItem.length) {
                lastScrollItem = this.inner.find('.item__outer').eq(0);
            }

            if(orientation && orientation === 'vertical') {
                this.slider.addClass('vertical__scroll').removeClass('horizontal__scroll');
            }
            else if(orientation && orientation === 'horizontal') {
                this.slider.addClass('horizontal__scroll').removeClass('vertical__scroll');
            }
            else if(this.initOrientation === 'vertical') {
                this.slider.addClass('vertical__scroll').removeClass('horizontal__scroll');
            }
            else {
                this.slider.addClass('horizontal__scroll').removeClass('vertical__scroll');
            }

            this.addActiveClass(init);

            return lastScrollItem.index();
        }
        setItemWidth(init) {
            this.outer.css("max-width", "100%");
            let lastScroll = this.setOrientation(init);
            let gap = this.setItemGap();
            let width = this.getResponsiveItemsWidth();
            let outerData = this.elementData(this.outer[0]);

            this.slider.removeClass('jq__slider__init');
            this.outer.css("max-width", `${outerData.width}px`);

            if(this.isVerticalSlider()) {
                this.inner.width('');
                this.inner.find('.item__outer').width('');
              
                if(width) {
                    let itemHeight = (outerData.height/Number(width)) - (gap * (width - 1)/width);
                    this.inner.find('.item__outer').outerHeight(itemHeight);
                }
            }
            else {
                if(width) {
                    this.inner.find('.item__outer').height('');
                    let itemWidth = (outerData.width/Number(width)) - (gap * (width - 1)/width);
                    this.inner.find('.item__outer').outerWidth(itemWidth);
                    let total_width = this.getAllItemsWith();

                    this.inner.outerWidth(Math.ceil(total_width));
                }
                else {
                    let total_width = this.getAllItemsWith();
                    this.inner.outerWidth(Math.ceil(total_width));
                }
            }

            this.scrollTo(0, false).then(()=> {
                this.goTo(lastScroll);
                this.slider.addClass('jq__slider__init');
                this.options.callback && this.options.callback();
            });
        }

        isElementInView(element) {
            let wrapperData = this.elementData(this.outer[0]);
            let elementData = this.elementData(element);

            var isInLeft = Math.ceil(elementData.left) >= Math.ceil(wrapperData.left) && Math.ceil(wrapperData.right) >= Math.ceil(elementData.right);
            var isInTop = Math.ceil(elementData.top) >= Math.ceil(wrapperData.top) && Math.ceil(wrapperData.bottom) >= Math.ceil(elementData.bottom);

            return isInLeft && isInTop;
        }

        getAllItemsWith(setItemWidth) {
            let width = 0;
            let items = this.inner.find('.item__outer');

            for(let i=0; i<items.length; i++) {
                let _w = this.getPropertyValue(items[i], 'width');
                let _m_l = this.getPropertyValue(items[i], 'margin-left');
                let _m_r = this.getPropertyValue(items[i], 'margin-right');
                width += (_w + _m_l + _m_r);
                if(setItemWidth) {
                    items[i].style.width = _w + 'px';
                }
            }

            return width;
        }
        
        getPropertyValue(ele, property) {
            return Number(window.getComputedStyle(ele, null).getPropertyValue(property).replace(/[a-z]+/g,'')) || 0;
        }
        elementData(element) {
            let elementTop = $(element).offset().top;
            let elementLeft = $(element).offset().left;
            let elementBottom = elementTop + $(element).outerHeight();
            let elementRight = elementLeft + $(element).outerWidth();

            return {
                top: elementTop,
                left: elementLeft,
                bottom: elementBottom,
                right: elementRight,
                width: $(element).outerWidth(),
                height: $(element).outerHeight(),
                paddingLeft: this.getPropertyValue(element, 'padding-left'),
                paddingRight: this.getPropertyValue(element, 'padding-right'),
                paddingTop: this.getPropertyValue(element, 'padding-top'),
                paddingBottom: this.getPropertyValue(element, 'padding-bottom'),
                marginLeft: this.getPropertyValue(element, 'margin-left'),
                marginRight: this.getPropertyValue(element, 'margin-right'),
                marginTop: this.getPropertyValue(element, 'margin-top'),
                marginBottom: this.getPropertyValue(element, 'margin-bottom'),
                cssleft: this.getPropertyValue(element, 'left'),
                cssTop: this.getPropertyValue(element, 'top')
                //height: Number(window.getComputedStyle(element, null).getPropertyValue('height').replace(/[a-z]+/g,''))
            }
        }

        setDelayFunction() {
            let timer = 0;
            return (callback, ms)=> {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        }
    }

    $.fn.jqSlider = function (option, data1, data2) {
        return this.each(function () {
            var _this = $(this),
                data = _this.data('jq.slider');
            if (!data) {
                data = new slider(this, typeof option === 'object' && option);
                _this.data('jq.slider', data);
            } else if (data && typeof option === 'string') {
                data[option].apply(data, [data1, data2]);
            }
        });
    };

    $("body").on("goTo", ".jq__slider", function(e, item_index, focusClass) {
      let data = $(this).data("jq.slider");
      if(data) {
        $(this).jqSlider('goTo', item_index, focusClass);
      }
      else {
        let time = setInterval(()=> {
          let data = $(this).data("jq.slider");
          if(data) {
            $(this).jqSlider('goTo', item_index, focusClass);
            clearInterval(time);
            time = null;
          }
        }, 500);
      }
    });
  
}(jQuery));



Shopify.formatMoney = Shopify.formatMoney || function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getElement(elements, callback) {
  if(!elements) return;
  for(let i = 0; i<elements.length; i++) {
    let val = callback(elements[i], i);
    if(val === false) {
      break;
    }
  }
}
function getSelectedVariantValues(_class, _onlyVisiable, _last_index) {
  let value = "";
  getElement(document.getElementsByClassName(_class), (ele, index)=> {
    let _tab_count = Number(ele.getAttribute("data-tabcount"));
    if(_onlyVisiable) {
      if(ele.offsetParent !== null) {
        value += value ? ` / ${ele.textContent}` : ele.textContent;
      }
    }
    else {
      value += value ? ` / ${ele.textContent}` : ele.textContent;
    }

    if(_last_index && _last_index === _tab_count) {
      return false;
    }
  });
  return value;
}
function selectVariant(ele) {
  //selectVariantByTitle(ele.textContent, ele.getAttribute("data-option"));
  
  let tab = ele.closest(".details_tab");
  let next_tab = tab.nextElementSibling;

  //tab.querySelector(".tab__title").classList.remove("open");

  if(next_tab) {
    //next_tab.querySelector(".tab__title").classList.add("open");
    
    getElement(next_tab.querySelectorAll(".scroll-swatches"), (ele)=> {
      ele.dispatchEvent(new Event("load"));
    });

    scrollToElement(next_tab);
  }
}

/*function selectVariant(ele) {
  let select = document.getElementById('productSelect');
  let value = ele.textContent;
  let wrapper = ele.closest(".details_tab");

  getElement(wrapper.getElementsByClassName('select__label'), (ele)=> {
    ele.classList.remove("selected");
  });
  ele.classList.add("selected");
  wrapper.getElementsByClassName('selected__value')[0].textContent = value;

  let selected_values = getSelectedVariantValues('selectd__variant__value');

  getElement(select.getElementsByTagName('option'), (option, index)=> {
    let text = option.textContent.trim();
    if(text.includes(selected_values)) {
      select.selectedIndex = index;
    }
  });
}*/

function selectVariantByTitle(title, position) {
  if(!title) return;
  if(!position) return;
  
  document.querySelector(`.details_tab[data-option="${position}"]`).querySelector('.selected__value').textContent = title.trim();

  let select = document.getElementById('productSelect');
  let selected_values = getSelectedVariantValues('selectd__variant__value');
  let __variant = product_json["variants"].find((item)=> {
    if(item.title === selected_values) {
      return item;
    }
  });

  if(__variant && __variant.id) {
    select.value = __variant.id;
    triggerEvent(select, "change");
  }
}

function getsystemdatetime() {
  var date = new Date();
  var dateFormat = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
  return dateFormat;
}

function getImageIndex(arr, url) {
  for(let i=0; i<arr.length; i++) {
    if(arr[i] === url) {
      return i;
      break;
    }
  }
  return null;
}

function formatDate(dateString) {
    // Convert the string to a Date object
    const date = new Date(dateString);
    
    // Format the Date object to "Month Day, Year"
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    
    return formattedDate;
}

function selectVarientCallback(__id) {
  let select = document.getElementById('productSelect');
  if(!select) return;
  let variant_id = select.value || __id;
  if(!variant_id) return;
  let variant = product_json["variants"].find((item)=> {
    if(item.id === Number(variant_id)) {
      return item;
    }
  });
  let values = variant.options;
  let allVariantShipping = document.querySelectorAll("#VariantShipping .hidden");
  let sku = variant.sku;

  getElement(values, (value, index)=> {
    let selector = `.details_tab[data-option="${index+1}"]`;
    let tab = document.querySelector(selector);
    let options = tab.querySelectorAll(".variant__option");
    let variant_input_id = `#variant-name${index+1}`;
    
    getElement(options, (option)=> {
      let text = option.textContent.trim();
      if(value === text) {
        option.classList.add("selected");
        tab.querySelector('.selected__value').textContent = value;
        tab.classList.add("__selected");
      }
      else {
        option.classList.remove("selected");
      }
    });

    if(document.querySelector(variant_input_id)) {
      document.querySelector(variant_input_id).value = value;
    }

    /*if(index === 0) {
      selectSwatchByTitle(value);
    }*/
  });

  //selectSwatchById(variant_id);

  let selectedVariantShipping = document.querySelector("#VariantShipping .shown");
  let VariantShipping = document.querySelector(`#pdpCallouts [id="${variant_id}"]`);
  var remaingClusuredays = 0;

  if(selectedVariantShipping) {
    selectedVariantShipping.classList.remove("shown");
    selectedVariantShipping.classList.add("hidden");
  }
  
  if(VariantShipping) {
    VariantShipping.classList.remove("hidden");
    VariantShipping.classList.add("shown");
    remaingClusuredays = parseInt($(VariantShipping).attr("data-dayleft"));
  }
  
  document.querySelector(".variant-sku").textContent = `SKU: ${sku}`;

  if(variant.featured_image) {
    let index = getImageIndex(product_json.images, variant.featured_image.src);
    if(index !== null) {
      $(".product-main-carousel").trigger('goTo', [index, true]);
    }
  }

  // leadtime variables
  let bo = backorder[variant.id];
  let lt = leadtime[variant.id];
  let ltOrg = leadtime[variant.id];
  let qty = quantity[variant.id];
  let sf = shipsFrom[variant.id];
  let sv = shipsVia[variant.id];
  let boDate = new Date(bo);
  let boDateString = '';
  
  // Variant total lead time
  let vLeadTime = vTotalLeadTime[variant.id];

  if (!isNaN(boDate.getTime())) {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Remove time component

    if (boDate > currentDate) {
      boDateString = ' until ' + formatDate(bo);
    }
  }
    
  // Variant total lead time
  let variantVendor = variantVendors[variant.id];

  let ltd = parseInt(lt);
  let bod = parseInt(bo);

  let systemdatetime = getsystemdatetime();

  // determine if it is UPS/parcel     
      var parcel = false;
      	if (/[p][a][r][c][e][l]/i.test(sv)) {
      		parcel = true;
      	}

     var freight = false;
      	if (/[f][r][e][i][g][h][t]/i.test(sv)) {
      		freight = true;
      	}
      
    var tempQuickShip = false;    
    if (sf == 'usa' || sf == 'united states' || sf == 'united-states' || sf == 'us' || sf == 'canada') {
      var tempQuickShip = true;
    }

  
     var shipBufferDays = 0;
     var sfLower = '';

     if(parseInt(vLeadTime) > 0) {
       var tlt = parseInt(vLeadTime) + parseInt(remaingClusuredays);
       var isBufferDays = true;
     } else {  
         if(sf != '') { var sfLower = sf.toLowerCase(); }
             
         if (sfLower == 'united states' || sfLower == 'usa' || sfLower == 'us') {
           if (freight == true) {
             var shipBufferDays = 10;
           } else if (parcel == true) {
             var shipBufferDays = 7;
           }
         } else if (sfLower == 'canada') {
           if (freight == true) {
             var shipBufferDays = 20;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         } else if (sfLower == 'belgium' || sfLower == 'denmark' || sfLower == 'estonia' || sfLower == 'finland' || sfLower == 'france' || sfLower == 'germany' || sfLower == 'holland') {
           if (freight == true) {
             var shipBufferDays = 40;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         } else if (sfLower == 'bosnia' || sfLower == 'czech republic' || sfLower == 'czech-republic' || sfLower == 'italy' || sfLower == 'portugal' || sfLower == 'slovenia' || sfLower == 'spain' || sfLower == 'uk' || sfLower == 'united kingdom') {
           if (freight == true) {
             var shipBufferDays = 45;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         } else if (sfLower == 'vietnam') {
           if (freight == true) {
             var shipBufferDays = 46;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         } else if (sfLower == 'turkey') {
           if (freight == true) {
             var shipBufferDays = 50;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         } else if (sfLower == 'china' || sfLower == 'japan') {
           if (freight == true) {
             var shipBufferDays = 60;
           } else if (parcel == true) {
             var shipBufferDays = 10;
           }
         }
    
         if(shipBufferDays == 0) {
    		var isBufferDays = false;
    	 } else {
    	    var isBufferDays = true;
    	 }
      
          var tlt = parseInt(ltd) + parseInt(shipBufferDays) + parseInt(remaingClusuredays);
     }

    // convert to weeks
    var ltw = parseInt(tlt/7);
    var ltwPLusTwo = ltw+2;
    var ltwRange = ltw + '-' + ltwPLusTwo;
    
    var outOfStockNote = false;
    var qsWeeks = 2;
    //var madeToOrderDays = parseInt(tlt) - parseInt(remaingClusuredays);
    var madeToOrderDays = parseInt(ltOrg);

    if(madeToOrderDays > 15 || product_json.tags.includes("*made-to-order")) {
      jQuery('#made-to-order-item').val('No cancellations or returns');
    } else {
      jQuery('#made-to-order-item').val('');
    }
  
    if(ltw <= qsWeeks && tempQuickShip == true && variant.inventory_management == 'shopify') {
      if(variant.inventory_quantity < 1) {
        if (tlt <= 14 && tempQuickShip && bo == '') {
          var outOfStockNote = true;
          jQuery('#fromDate').html("<input id=\"leadtimeNote\" type=\"hidden\" name=\"properties[Note]\" value=\"Item is available on backorder.\" readonly />");
          jQuery('#variant-inventory').text("Item is available on backorder.");
        } else if (tlt <= 14 && tempQuickShip && bo != '') {
          var outOfStockNote = true;
          jQuery('#fromDate').html("<input id=\"leadtimeNote\" type=\"hidden\" name=\"properties[Note]\" value=\"Item is available on backorder until " + bo + "\" readonly />");
          jQuery('#variant-inventory').text("Item is available on backorder " + boDateString);
        } else if (tlt > 14 && tlt <= 28 && tempQuickShip && bo == '') {
          var outOfStockNote = true;
          jQuery('#fromDate').html("<input id=\"leadtimeNote\" type=\"hidden\" name=\"properties[Note]\" value=\"Item is available on backorder.\" readonly />");
          jQuery('#variant-inventory').text("Item is available on backorder");
        } else {
          jQuery('#variant-inventory').text("");
        }
      }
    }

    if(outOfStockNote == false) {
      // if there is a backorder date
      if (toTimestamp(bo) > toTimestamp(systemdatetime)) {
        if((variant.inventory_management === 'shopify' && variant.inventory_quantity <= 0) || variant.inventory_management !== 'shopify') {
          jQuery('#fromDate').html('<input id=\"leadtimeNote\" type=\"text\" name=\"properties[Back in stock]\" value=\"' + bo + '" readonly />'); 
        }
      } else if (isBufferDays == false) {
        jQuery('#fromDate').html('<input id=\"leadtimeNote\" type=\"text\" name=\"properties[Average Leadtime]\" value=\"Call For Leadtime" readonly />'); 
      } else if (tlt < 15) {
        if (variant.inventory_quantity < 1 && variant.inventory_management == 'shopify') { 
            jQuery('#fromDate').html('<input id=\"leadtimeNote\" type=\"text\" name=\"properties[Average Leadtime]\" value=\"Contact Us" readonly />');
        } else {
            jQuery('#fromDate').html('<input id=\"leadtimeNote\" type=\"text\" name=\"properties[Average Leadtime]\" value=\"Under 2 Weeks" readonly />'); 
        } 
      } else if (tlt >= 15) {
        jQuery('#fromDate').html('<input id=\"leadtimeNote\" type=\"text\" name=\"properties[Average Leadtime]\" value=\"About ' + ltwRange + ' Weeks" readonly />'); 
      } else {
        jQuery('#fromDate').html('Contact Us');
      }
    }
  
     // if shipsVia is freight
    if (sv == 'freight')  {
    jQuery('#shipsVia').html('<input id=\"shipsviaNote\" type=\"text\" name=\"properties[Ships Via]\" value=\"Freight" readonly />'); }
    else if (sv == 'parcel') {
    jQuery('#shipsVia').html('<input id=\"shipsviaNote\" type=\"text\" name=\"properties[Ships Via]\" value=\"Parcel" readonly />'); }

    if (variant.inventory_management == "shopify") {
      if(variantVendor == 'bibo' || variantVendor == 'box in box out' || variantVendor == 'ait worldwide logistics' || variantVendor == 'ait') {
            if (variant.inventory_quantity <= 0) {
              if(outOfStockNote == false) {
                  /*if(bo == '') {
                      jQuery('#variant-inventory').html('Low inventory. <a href="/pages/contact-a-sales-rep" target="_blankber">Contact us</a> for additional support.');
                  } else {
                      jQuery('#variant-inventory').html('Low inventory. <a href="/pages/contact-a-sales-rep" target="_blankber">Contact us</a> for additional support. <input id=\"note\" type=\"hidden\" name=\"properties[Note]\" value=\"On backorder.\" readonly />');
                  }*/

                  jQuery('#variant-inventory').html('Item is on backorder '+boDateString+' <input id=\"note\" type=\"hidden\" name=\"properties[Note]\" value=\"On backorder.\" readonly />');
              }
          } else {
                jQuery('#variant-inventory').html('' + variant.inventory_quantity + ' in stock');
         }
      } else {
          if (variant.inventory_quantity > 0) {
              jQuery('#variant-inventory').html('' + variant.inventory_quantity + ' in stock');
              
              if(variantVendor != 'bibo' && variantVendor != 'box in box out' && variantVendor != 'diligent la' && variantVendor != 'diligent' && variantVendor != 'diligent nj' && variantVendor != 'diligent stock' && variantVendor != 'ait worldwide logistics') {  
                jQuery('#vendorInventoryMsg').html('<input id=\"vendorInventoryNote\" type=\"text\" name=\"properties[Vendor Inventory]\" value=\"Subject to Availability" readonly />');
              }              
          } else if (variant.inventory_quantity <= 0  && outOfStockNote == false) {
              /*if(bo == '') {
                  jQuery('#variant-inventory').html('Low inventory. <a href="/pages/contact-a-sales-rep" target="_blankber">Contact us</a> for additional support.');
              } else {
                  jQuery('#variant-inventory').html('Low inventory. <a href="/pages/contact-a-sales-rep" target="_blankber">Contact us</a> for additional support. <input id=\"note\" type=\"hidden\" name=\"properties[Note]\" value=\"On backorder.\" readonly />');
              }*/

              jQuery('#variant-inventory').html('Item is on backorder '+boDateString+' <input id=\"note\" type=\"hidden\" name=\"properties[Note]\" value=\"On backorder.\" readonly />');
          }
      }
    } else {
      jQuery('#variant-inventory').text("");
      }
      setTimeout(function() {
          $('#product-carousel').trigger('change.variant', [variant]);
      }, 100);

    timber.productPage({
      money_format: money_format,
      variant: variant,
      selector: select
    });

    /** SUMMER WEEK CODE START **/
    /*$(".summer-closure").remove();
    if(vendorClosureList.includes(variantVendor.toLowerCase())) {
      let cdate = new Date()
      let day = cdate.getDate();
      let month = cdate.getMonth() + 1;
      let year = cdate.getFullYear();
      // This arrangement can be altered based on how we want the date's format to appear.
      let currentDate = `${day}-${month}-${year}`;
      //console.log('currentDate', currentDate); // "17-6-2022"

      $.ajax({
        type: 'POST',
        url: '/apps/dpg-hni/products/summer-closure/999',
        dataType: 'json',
        cache: false,
        data: {vendor:variantVendor, sDate:currentDate},
        success: function (response) {
          if(response.type == 'success') {
              $('.add__to__cart__section').before( "<h4 class='summer-closure'>"+response.description+"</h4>" );
          }
        }
      });
    }*/
   /** SUMMER WEEK CODE END **/

  return variant;
}




function smoothScrool(val, callback, step = 10) {
  if(window.scrollY >= val) {
    callback && callback();
    return;
  };
  
  let scroll = window.scrollY + step;
  if(scroll > val) {
    scroll = (val - window.scrollY) + window.scrollY;
    window.scrollTo(0, scroll);
    callback && callback();
    return;
  }
  
  setTimeout(()=> {
    smoothScrool(val, callback, step);
  }, 30);
}

function scrollToElement(ele, callback) {
  if(!ele) return;
  setTimeout(()=> {
    let offsetTop = ele.offsetTop + ele.offsetHeight + 20;
    let totalScroll = window.scrollY + window.innerHeight;
    let restScroll = offsetTop - totalScroll;
  
    if(restScroll > 0) {
      window.scrollTo(0, (offsetTop - window.innerHeight));
      //smoothScrool((offsetTop - window.innerHeight), callback);
    }
  }, 50);
  /*setTimeout(()=> {
    $("html, body").animate({ scrollTop: $(ele).offset().top }, 600);
  }, 100);*/
}

function isInViewport(element) {
  if(element.offsetParent === null) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function lazyLoadImage(options, callback) {
  let wrapper = options.wrapper ? Array.from(document.querySelectorAll(options.wrapper)) : null;
  wrapper = (wrapper && wrapper.length) ? wrapper : Array.from(document.querySelectorAll("body"));
  
  let isInViewport = (element)=> {
    if(element.offsetParent === null) {
      return false;
    }
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  let apply = ()=> {
    for(let wrap of wrapper) {
      let elements = wrap.querySelectorAll(options.selector);
      for(let element of elements) {
        if(isInViewport(element) && !element.classList.contains("__loaded")) {
          element.classList.add("__loaded");
          options.callback && options.callback(element);
        }
      }
    }
  };

  apply();

  for(let wrap of wrapper) {
    wrap.addEventListener("scroll", ()=> {
      apply();
    });
    wrap.addEventListener("load", ()=> {
      apply();
    });
  }

  document.querySelector("html").addEventListener("scroll", ()=> {
    apply();
  });
  document.querySelector("body").addEventListener("scroll", ()=> {
    apply();
  });
  document.addEventListener("scroll", ()=> {
    apply();
  });
  window.addEventListener("scroll", ()=> {
    apply();
  });
  window.addEventListener("resize", ()=> {
    apply();
  });
}

function selectSwatchById(id) {
  if(!id) return;

  let isTwotone = !!document.querySelector(".sw-option-1, .sw-option-2, .fabricSwatchesTabs");

  // Twotone: only auto-select Step 1 (Upholstery). Never match Frame / sw-option-2
  // (those Liquid finish anchors share the default variant id and were wrongly preselected).
  let link = null;
  if(isTwotone) {
    link =
      document.querySelector(".sw-option-1 .product-swatches-alt [href='#" + id + "'], .sw-option-1 .product-swatches [href='#" + id + "']") ||
      document.querySelector(".product-swatches [href='#" + id + "']") ||
      null;
    if(!link) {
      let candidates = document.querySelectorAll(".product-swatches-alt [href='#" + id + "']");
      for(let i = 0; i < candidates.length; i++) {
        if(!candidates[i].closest(".sw-option-2")) {
          link = candidates[i];
          break;
        }
      }
    }
  } else {
    link = document.querySelector(".product-swatches [href='#" + id + "'], .product-swatches-alt [href='#" + id + "']");
  }

  if(!link) return;
  if(link.closest(".sw-option-2")) return;

  let title = (link.getAttribute("title") || "").trim();
  let link_by_title = document.querySelector(".product-swatches .variant.shown [title='" + title + "']");

  if(!link_by_title && link.closest(".product-swatches-alt")) {
    link_by_title = link;
  }
  if(!link_by_title) return;
  if(link_by_title.closest(".sw-option-2")) return;

  let scopeRoot = link_by_title.closest(".sw-option-1") || document;

  let activeInScope = scopeRoot.querySelector(".product-swatches-alt .variant a.select, .product-swatches .variant a.select");
  if(activeInScope && activeInScope !== link_by_title) {
    activeInScope.classList.remove("select");
  }

  let legacySelect = document.querySelector(".product-swatches .variant a.select");
  if(legacySelect && legacySelect !== link_by_title) {
    legacySelect.classList.remove("select");
  }

  link_by_title.classList.add("select");

  let tab = link_by_title.closest(".details_tab");
  let img = link_by_title.querySelector("img");
  let src = img ? (img.getAttribute("data-src") || img.getAttribute("src") || "") : "";
  if(!src && link_by_title.style.backgroundImage) {
    src = link_by_title.style.backgroundImage.replace(/^url\(["']?/, "").replace(/["']?\)$/, "");
  }
  let displayTitle = (
    link_by_title.getAttribute("data-fabric-category") ||
    title ||
    link_by_title.getAttribute("data-group") ||
    link_by_title.getAttribute("data-option-value") ||
    ""
  ).trim();

  // Only update Upholstery / Step 1 UI from variant-id sync
  if(tab) {
    let value1 = tab.querySelector(".selectd__upholstery__value");
    if(value1) value1.textContent = displayTitle;
  }

  let fabSwatch = document.querySelector(".fabSwatch");
  if(fabSwatch) {
    fabSwatch.value = src;
  }

  let fabric = document.querySelector(".fabric");
  if(fabric && src) {
    fabric.querySelector(".fab-span").style.backgroundImage = `url(${src})`;
    fabric.querySelector(".fab-span-title").innerHTML = displayTitle;
    fabric.closest(".selected__fabric").classList.remove("hidden");
    if(document.querySelector(".selfabric")) {
      document.querySelector(".selfabric").value = displayTitle;
    }
  }

  let input1 = document.querySelector(".selfabric");
  let input2 = document.querySelector(".selfabric2");
  let bothSelected = !input2 || !!(input1 && input1.value.trim() && input2.value.trim());

  if(tab) {
    if(bothSelected) {
      tab.classList.add("__selected");
    } else if(isTwotone) {
      tab.classList.add("__partial");
      tab.classList.remove("__selected");
    } else {
      tab.classList.add("__selected");
    }
  }

  if(bothSelected) {
    if($( ".addtocart" ).hasClass( "hidden" )) {
      $('.addtocart').removeClass('hidden').show();
      $('.addtocartDefault').addClass('hidden').hide();
    }
  }
}

function selectSwatchByTitle(title) {
  let fabSwatch = document.querySelector(".fabSwatch");
  let link;

  getElement(document.querySelectorAll(".product-swatches .variant"), (variant, index)=> {
    let _link = variant.querySelector('a');
    let _title = _link.getAttribute("title");
    let _style = variant.getAttribute("style") || "";
    if(_title && _title.trim() === title && _style.includes("display") === false) {
      let select = document.querySelector(".product-swatches .variant a.select");
      let tab = _link.closest(".details_tab");
      if(select) {
        select.classList.remove("select");
      }
      _link.classList.add("select");
      tab.classList.add("__selected");
      document.querySelector(".selectd__upholstery__value").textContent = _title.trim();
      link = variant;
      return false;
    }
  });

  if(link && fabSwatch) fabSwatch.value = link.querySelector("img").getAttribute("data-src");
}

function clearUpholsteryFabricError() {
  let errorSpan = document.querySelector(".add__to__cart_error");
  if(!errorSpan) return;
  errorSpan.classList.remove("shown");
  // Inline display was previously forced on partial two-tone selection — always reset it
  errorSpan.style.display = "";
}

function twotoneBothFabricsSelected() {
  let input1 = document.querySelector(".selfabric");
  let input2 = document.querySelector(".selfabric2");
  if(!input2) return true;
  let val1 = (input1 && input1.value.trim()) || (document.querySelector(".selectd__upholstery__value") || {}).textContent || "";
  let val2 = (input2 && input2.value.trim()) || (document.querySelector(".selectd__upholstery__value2") || {}).textContent || "";
  return !!(String(val1).trim() && String(val2).trim());
}

function clickVariantImage(link) {
  // Prefer data-fabric-category (Shopify option / group key) over title/data-group (fabric type)
  let link_title = (
    link.getAttribute("data-fabric-category") ||
    link.getAttribute("title") ||
    link.getAttribute("data-group") ||
    ""
  ).trim();
  let img = link.querySelector("img");
  let img_title = (img && (img.getAttribute("title") || link_title)) || link_title;
  let data_src = img ? (img.getAttribute("data-src") || img.getAttribute("src")) : "";
  if(!data_src && link.style.backgroundImage) {
    data_src = link.style.backgroundImage.replace(/^url\(["']?/, "").replace(/["']?\)$/, "");
  }
  let fabSwatch = document.querySelector(".fabSwatch");
  let fabric = document.querySelector(".fabric");
  let fabric2 = document.querySelector(".fabric2");
  let isAltSwatch = link.closest(".product-swatches-alt");
  let btn = document.getElementById("AddToCart");
  let select = document.getElementById('productSelect');

  let fabric_image_src;
  let fabric_image_src_1;
  let fabric_image_src_2;

  if(fabSwatch) {
    fabSwatch.value = data_src;
  }

  if(img && img.closest('.sw-option-1')) {
    fabric_image_src_1 = data_src;
  }
  else if(img && img.closest('.sw-option-2')) {
    fabric_image_src_2 = data_src;
  }
  else {
    fabric_image_src = data_src;
  }

  if(fabric) {
    fabric.querySelector(".fab-span").classList.remove("__no__image");
  }
  
  if(fabric2) {
    fabric2.querySelector(".fab-span2").classList.remove("__no__image");
  }

  if(fabric_image_src) {
    getElement(document.querySelectorAll(".variant a.select"), (ele)=> {
      ele.classList.remove("select");
    });
    
    if(fabric) {
      fabric.querySelector(".fab-span").style.backgroundImage = `url(${fabric_image_src})`;
      fabric.querySelector(".fab-span-title").innerHTML = img_title;
      fabric.closest(".selected__fabric").classList.remove("hidden");
      if(document.querySelector(".selfabric")) {
        document.querySelector(".selfabric").value = img_title;
      }

      if(link.classList.contains("__no__image")) {
        fabric.querySelector(".fab-span").classList.add("__no__image");
      }
    }

    if(document.querySelector(".add__to__cart_error")) {
      clearUpholsteryFabricError();
    }
    
    //link.closest(".details_tab").querySelector(".tab__title").classList.remove("open");
    
    document.querySelector(".upholstery__tab").classList.add("__selected");
    document.querySelector(".selectd__upholstery__value").textContent = link_title;
    $('.addtocart').removeClass('hidden').show();
    $('.addtocartDefault').addClass('hidden').hide();
    //scrollToElement(btn);
  }
  else if(fabric_image_src_1) {
    getElement(document.querySelectorAll(".sw-option-1 .variant a.select"), (ele)=> {
      ele.classList.remove("select");
    });
    
    if(fabric) {
      fabric.querySelector(".fab-span").style.backgroundImage = `url(${fabric_image_src_1})`;
      fabric.querySelector(".fab-span-title").innerHTML = img_title;
      fabric.closest(".selected__fabric").classList.remove("hidden");
      document.querySelector(".selfabric").value = img_title;

      if(link.classList.contains("__no__image")) {
        fabric.querySelector(".fab-span").classList.add("__no__image");
      }
    }
    
    document.querySelector(".selectd__upholstery__value").textContent = link_title;
    clearUpholsteryFabricError();
    if(twotoneBothFabricsSelected()) {
      document.querySelector(".upholstery__tab").classList.add("__selected");
      $('.addtocart').removeClass('hidden').show();
      $('.addtocartDefault').addClass('hidden').hide();
    }
    $($(".fabricSwatchesTabs > div").eq(1)).click();
  }
  else if(fabric_image_src_2) {
    getElement(document.querySelectorAll(".sw-option-2 .variant a.select"), (ele, index)=> {
      ele.classList.remove("select");
    });

    if(fabric2) {
      fabric2.querySelector(".fab-span2").style.backgroundImage = `url(${fabric_image_src_2})`;
      fabric2.querySelector(".fab-span-title").innerHTML = img_title;
      fabric2.closest(".selected__fabric2").classList.remove("hidden");
      document.querySelector(".selfabric2").value = img_title;

      if(link.classList.contains("__no__image")) {
        fabric2.querySelector(".fab-span2").classList.add("__no__image");
      }
    }
    
    //link.closest(".details_tab").querySelector(".tab__title").classList.remove("open");
    
    document.querySelector(".selectd__upholstery__value2").textContent = link_title;
    clearUpholsteryFabricError();
    if(twotoneBothFabricsSelected()) {
      document.querySelector(".upholstery__tab").classList.add("__selected");
      $('.addtocart').removeClass('hidden').show();
      $('.addtocartDefault').addClass('hidden').hide();
    }
    //scrollToElement(btn);
  }

  link.classList.add("select");

  // Final pass: once both twotone options are chosen, always clear sticky error
  if(twotoneBothFabricsSelected()) {
    clearUpholsteryFabricError();
  }

  let upholstery_value = document.querySelector(".selectd__upholstery__value")?.textContent;
  if(upholstery_value) {
    let upholstery_value2 = document.querySelector(".selectd__upholstery__value2")?.textContent;
    let total_upholstery_value = upholstery_value;
    let selectedVariantValues = getSelectedVariantValues('selectd__variant__value', true);
    if(upholstery_value2) {
      total_upholstery_value += " / " + upholstery_value2;
    }
    total_upholstery_value = total_upholstery_value + (selectedVariantValues ? (" / " + selectedVariantValues) : "");
    let variant_by_upholstery_value = product_json["variants"].find((item)=> {
      if(item.title === total_upholstery_value) {
        return item;
      }
    });
  
    if(variant_by_upholstery_value) {
      select.value = variant_by_upholstery_value.id;
      triggerEvent(select, "change");
    }
    else {
      let variant = null;
      for(let item of getFilterVariants()) {
        if(item.option1 === upholstery_value) {
          variant = item;
        }
        if(variant && upholstery_value2 === "") {
          variant = null;
        }
        else if(variant && upholstery_value2 && item.option2 !== upholstery_value2) {
          variant = null;
        }
        if(variant) {
          break;
        }
      }

      if(variant) {
        select.value = variant.id;
        triggerEvent(select, "change");
      }
    }
  }
}

function clickVariantTwoImage(link) {
  let title_01 = link.getAttribute("data-name-one");
  let title_02 = link.getAttribute("data-name-two");
  let images = link.querySelectorAll("img");
  let fabric_01 = document.querySelector(".fabric");
  let fabric_02 = document.querySelector(".fabric2");
  let fabSwatch = document.querySelector(".fabSwatch");

  let fabric_image_src_1 = images[0].getAttribute("src");
  let fabric_image_src_2 = images[1].getAttribute("src");
  let image_title_01 = images[0].getAttribute("name");
  let image_title_02 = images[1].getAttribute("name");
  let select = document.getElementById('productSelect');

  if(fabSwatch) {
    fabSwatch.value = fabric_image_src_1;
  }

  getElement(document.querySelectorAll(".variant a.select"), (ele)=> {
    ele.classList.remove("select");
  });

  if(fabric_01) {
    fabric_01.querySelector(".fab-span").style.backgroundImage = `url(${fabric_image_src_1})`;
    fabric_01.querySelector(".fab-span-title").innerHTML = image_title_01;
    fabric_01.closest(".selected__fabric").classList.remove("hidden");
    document.querySelector(".selfabric").value = title_01;
  }

  if(fabric_02) {
    fabric_02.querySelector(".fab-span2").style.backgroundImage = `url(${fabric_image_src_2})`;
    fabric_02.querySelector(".fab-span-title").innerHTML = image_title_02;
    fabric_02.closest(".selected__fabric2").classList.remove("hidden");
    document.querySelector(".selfabric2").value = title_02;
  }

  if(document.querySelector(".add__to__cart_error")) {
    document.querySelector(".add__to__cart_error").classList.remove("shown");
  }

  document.querySelector(".selectd__upholstery__value").textContent = title_01;
  document.querySelector(".selectd__upholstery__value2").textContent = title_02;

  link.classList.add("select");

  let upholstery_value = document.querySelector(".selectd__upholstery__value").textContent;
  let selectedVariantValues = getSelectedVariantValues('selectd__variant__value', true);
  if(document.querySelector(".selectd__upholstery__value2")) {
    upholstery_value += " / " + document.querySelector(".selectd__upholstery__value2").textContent;
  }
  upholstery_value = upholstery_value + (selectedVariantValues ? (" / " + selectedVariantValues) : "");
  let variant_by_upholstery_value = product_json["variants"].find((item)=> {
    if(item.title === upholstery_value) {
      return item;
    }
  });

  if(variant_by_upholstery_value) {
    select.value = variant_by_upholstery_value.id;
    triggerEvent(select, "change");
  }
}

function add_event(_selector, _eventName, _callback) {
  let elements = document.querySelectorAll(_selector);
  getElement(elements, (element, index)=> {
    element.addEventListener(_eventName, _callback);
  });
}

function triggerEvent(_ele, _event) {
  if(!_ele) return;
  _ele.dispatchEvent(new CustomEvent(_event, {detail: 1}));
}

function errorImage(img) {
  let link = img.closest('a');
  let src = img.getAttribute("data-fsrc");
  link.style.backgroundImage = `url(${src})`;
  img.setAttribute("src", src);
  img.setAttribute("data-src", src);
  img.setAttribute("onerror", `errorImage2(this)`);
}

function errorImage2(img) {
  let link = img.closest('a');
  img.removeAttribute("onerror");
  img.setAttribute("src", swatch_placeholder);
  img.setAttribute("data-src", swatch_placeholder);
  link.style.backgroundImage = `url(${swatch_placeholder})`;
  link.classList.add("__no__image");
  console.log(`swatch_placeholder`, swatch_placeholder);
}

function domObserver(selecter, options, callback) {
  let elements = document.querySelectorAll(selecter);
  for (const ele of elements) {
    callback && callback({
      target: ele
    });
    new MutationObserver((mutationList, observer)=> {
      for (const mutation of mutationList) {
        callback && callback(mutation);
      }
    }).observe(ele, options);
  }
}

function delay_fun() {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}

function getVariantsByOption(option, val, variants) {
  let key = `option${option}`;
  if (typeof exclude_sku_list !== 'undefined') {
    return variants.filter((item)=> {
      if(item[key].toLowerCase() === val.toLowerCase() && exclude_sku_list.toUpperCase().includes(item.sku.toUpperCase()) === false) {
        return item;
      }
    });
  } else {
    return variants.filter((item)=> {
      if(item[key].toLowerCase() === val.toLowerCase()) {
        return item;
      }
    });
  }
}

function showHideVariantsOptions(filter_variants) {
  let all_variant_img = document.querySelectorAll(".upholstery__tab .variant");
  let all_option_variants_div = document.querySelectorAll("#option-variants");
  let first_options = [];
  let second_options = [];
  let shown_variants_title = [];

  getElement(filter_variants, (variant, index)=> {
    if(variant.option1 && !first_options.includes(variant.option1)) {
      first_options.push(variant.option1);
    }
    if(variant.option2 && !second_options.includes(variant.option2)) {
      second_options.push(variant.option2);
    }
  });

  getElement(all_variant_img, (variant, index)=> {
    let title = (variant.querySelector("a").getAttribute("title") || "").trim();
    let options = variant.closest(".sw-option-2") ? second_options : first_options;
    //template__name === "twotone"
    if(options.includes(title)) {
      variant.classList.add("shown");
      variant.classList.remove("hide");
    }
    else {
      variant.classList.add("hide");
      variant.classList.remove("shown");
    }
  });

  getElement(document.querySelectorAll(".product-swatches .variant.shown"), (variant, index)=> {
    let title = variant.querySelector("a").getAttribute("title") || "";
    if(!shown_variants_title.includes(title)) {
      shown_variants_title.push(title);
    }
    else {
      variant.classList.add("hide");
      variant.classList.remove("shown");
    }
  });

  getElement(all_option_variants_div, (variant_div, index)=> {
    let shown_variant = variant_div.querySelector(".variant.shown");
    if(shown_variant) {
      variant_div.classList.remove("hide");
    }
    else {
      variant_div.classList.add("hide");
    }
  });

  let upholstery_value1 = document.querySelector(".selectd__upholstery__value")?.textContent;
  let selected_swatches = document.querySelectorAll(".product-swatches .variant .select, .product-swatches-alt .variant .select");

  if(upholstery_value1 && !first_options.includes(upholstery_value1)) {
    document.querySelector(".upholstery__tab").classList.remove("__selected");
    
    if(document.getElementById("selfabric")) {
      document.getElementById("selfabric").value = "";
    }
    
    document.querySelector(".selectd__upholstery__value").textContent = "";
    document.querySelector(".selected__fabric").classList.add("hidden");

    if(document.getElementById("selfabric2")) {
      document.getElementById("selfabric2").value = "";
      document.querySelector(".selectd__upholstery__value2").textContent = "";
      document.querySelector(".selected__fabric2").classList.add("hidden");
    }

    if(document.querySelector(".addtocart")) {
      document.querySelector(".addtocart").style.display = "none";
    }

    if(document.querySelector(".addtocartDefault")) {
      document.querySelector(".addtocartDefault").style.display = "block";
    }

    getElement(selected_swatches, (link)=> {
      link.classList.remove("select");
    });
  }
}

function getFilterVariants() {
  let open_tab = document.querySelector(".details_tab.open");
  
  if(open_tab.classList.contains("upholstery__tab")) {
    return product_json.variants;
  }

  let main_option = Number(open_tab.getAttribute("data-option"));
  let selected_value = open_tab.querySelector(".selected").textContent.trim();
  
  return getVariantsByOption(main_option, selected_value, product_json.variants);
}

function showHideOptions() {
  let open_tab = document.querySelector(".details_tab.open");
  
  if(open_tab.classList.contains("upholstery__tab")) {
    showHideVariantsOptions(product_json.variants);
    return false;
  }
  
  let all_tab = document.querySelectorAll(".details_tab");
  let main_option = Number(open_tab.getAttribute("data-option"));
  let filter_variants = getFilterVariants();
  
  showHideVariantsOptions(filter_variants);

  getElement(all_tab, (tab, index)=> {
    if(index + 1 === main_option) return;
    getElement(tab.querySelectorAll(".variant__option"), (option)=> {
      option.classList.add("__hide");
    });
  });
  
  getElement(filter_variants, (variant)=> {
    getElement(variant.options, (value, index)=> {
      let tab = all_tab[index];
      let tab_options = tab.querySelectorAll(".variant__option");
      if(index + 1 === main_option) return;
      if(!tab_options) return;
      getElement(tab_options, (option)=> {
        if(value !== option.textContent.trim()) return;
        option.classList.remove("__hide");
      });
    });
  });

  getElement(all_tab, (tab, index)=> {
    let tab_options = tab.querySelectorAll(".variant__option");
    let hidden_selected = tab.querySelector(".variant__option.selected.__hide");
    
    if(hidden_selected) {
      hidden_selected.classList.remove("selected");
      getElement(tab_options, (option, index)=> {
        if(!option.classList.contains("__hide")) {
          tab.querySelector(".selectd__variant__value").textContent = option.textContent.trim();
          return false;
        }
      });
    }
  });

  return getSelectedVariantValues('selectd__variant__value');
}

/* SC Product Options UI disabled. Key Product Options renders its own option block.
//domObserver(document.querySelector('.bold_options'), {
domObserver('.bold_options', {
  childList: true,
  subtree: true
}, (mutation)=> {
  $('.details_tab_bold').trigger("bold.visible");
});

let bold_delay = delay_fun();
$('.details_tab_bold').on('bold.visible', function() {
  bold_delay(()=> {
    let bold_options_html = $('.bold_options').html().trim();
    if(!bold_options_html) return;
    let count = $(".details_tab:visible").length + 1;
    $(this).removeClass("hidden");
    $(this).find(".tab-count").remove();
    $(this).find(".details_tab_title").prepend(`<span class="tab-count">${count}</span>`);
    if($(this).find('.bold_option_error').length) {
      $(".details_tab_title").removeClass("open");
      $(this).find(".details_tab_title").addClass("open");
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".details_tab_bold").offset().top - 20
      }, 500);
    }
  }, 100);
});

$('.details_tab_bold').trigger("bold.visible");
*/

document.addEventListener('DOMContentLoaded', ()=> {
  // Initialize carousels without RGBaster
  $('.product-main-carousel').jqSlider({
    responsiveItems: {
        10: 1
    },
    beforeChange: (item, index)=> {},
    afterChange: (item, index)=> {
      $('.product-thumbs').trigger('goTo', [index, true]);
    }
  });

  $('.product-thumbs').jqSlider({
    beforeChange: (item, index)=> {},
    itemClick: (item, index)=> {
      $('.product-main-carousel').trigger('goTo', [index, true]);
    },
    afterChange: ()=> {},
    responsiveOrientation: {
        0: 'horizontal',
        1000: 'vertical'
    }
  });

  $('.tab__title').click(function(){
    if($(this).hasClass('open')) {
      $(this).removeClass('open');
    }
    else {
      $(this).addClass('open');
      $('.tab__title').not(this).removeClass('open');
      $(".scroll-swatches").each(function() {
        this.dispatchEvent(new Event("load"));
      });
    }
  });

  $(".fabricSwatchesTabs > div").click(function() {
    let index = $(this).index();
    $(this).addClass("active");
    $(".fabricSwatchesTabs > div").not(this).removeClass("active");
    let div = $(".fabricSwatchesBody .accordion-content").removeClass("default").eq(index).addClass("default");
    if(div.length) {
      div[0].dispatchEvent(new Event("load"));
    } 
  }); 

  lazyLoadImage({
    selector: ".variant a",
    wrapper: ".scroll-swatches",
    callback: (ele)=> {
      let img = ele.querySelector("img");
      let src = img.getAttribute("data-src") || img.getAttribute("src");
      img.setAttribute("src", src);
      if(!img.getAttribute("data-src")) {
        img.setAttribute("data-src", src);
      }
      img.setAttribute("onerror", `errorImage(this)`);
      ele.style.backgroundImage = `url(${src})`;
    }
  });

  let return_variant = selectVarientCallback();
  if(return_variant) {
    showHideOptions();
    selectSwatchById(return_variant.id);
  } else if (typeof product_json !== 'undefined') {
    var urlParams = new window.URLSearchParams(window.location.search);
    var urlParamsVariantId = urlParams.get('variant');
    let variant = product_json.variants[0];
    for(vi = 0; vi < product_json.variants.length; vi++) {
      if(urlParamsVariantId == product_json.variants[vi].id) {
        variant = product_json.variants[vi];
      }
    }

    if(variant) {
      let return_variant = selectVarientCallback(variant.id);
      showHideOptions();
      selectSwatchById(return_variant.id);
    }
  }
  
  add_event('#productSelect', 'change', function(event) {
    let return_variant = selectVarientCallback();
    selectSwatchById(return_variant.id);
  });

  add_event('.details_tab .variant__option', 'click', function(event) {
    let tab = this.closest('.details_tab');
    let tab_count = Number(this.getAttribute("data-tabcount"));
    let selected = tab.querySelector(".variant__option.selected");

    if(selected) {
      selected.classList.remove("selected");
    }
    this.classList.add("selected");
    tab.querySelector(".selectd__variant__value").textContent = this.textContent.trim();
    
    let selected_values = showHideOptions();
    if(selected_values) {
      let select = document.getElementById('productSelect');
      let _variant = product_json["variants"].find((item)=> {
        if(item.title === selected_values) {
          return item;
        }
      });
    
      if(_variant && _variant.id) {
        select.value = _variant.id;
        triggerEvent(select, "change");
      }
      else {
        let selected_values = getSelectedVariantValues('selectd__variant__value', true, tab_count);
        let filter_variants = getFilterVariants();
        let _variant;
        
        for(item of filter_variants) {
          if(item.title.includes(selected_values)) {
            _variant = item;
            break;
          }
        }

        if(_variant && _variant.id) {
          select.value = _variant.id;
          triggerEvent(select, "change");
        }
      }
    }
    //console.log(selected_values);
    selectVariant(this);
    event.preventDefault();
  });
  
  document.body.addEventListener('click', function(event) {
    const variantLink = event.target.closest('.click_variant_image .variant a');
    if (variantLink) {
      clickVariantImage(variantLink);
      event.preventDefault();
      return;
    }
    const variantTwoLink = event.target.closest('.click_variant_image .variant_two a');
    if (variantTwoLink) {
      clickVariantTwoImage(variantTwoLink);
      event.preventDefault();
    }
  });

  add_event('#cartBtn', 'click', function(event) {
    // Only prompt when fabrics are still missing
    if(typeof twotoneBothFabricsSelected === "function" && twotoneBothFabricsSelected()) {
      event.preventDefault();
      return;
    }
    if(document.querySelector(".add__to__cart_error")) {
      document.querySelector(".add__to__cart_error").classList.add("shown");
      document.querySelector(".add__to__cart_error").style.display = "";
      $(".upholstery__tab .tab__title").addClass("open");
      $([document.documentElement, document.body]).animate({
          scrollTop: $(".upholstery__tab").offset().top
      }, 500);
    }
    event.preventDefault();
  });

  domObserver('.bold_option_price_display', {
    childList: true,
    subtree: true
  }, (mutation)=> {
    $(mutation.target).trigger('change.price', [window.money_format]);
  });

  domObserver('#AddToCartForm', {
    childList: true,
    subtree: true
  }, (mutation)=> {
    let klaviyo_bis = $("#AddToCartForm > .klaviyo-bis-trigger");
    if(klaviyo_bis.length && klaviyo_bis.is(":visible")) {
      let wrapper = $(`<div class="add__to__cart__right" />`).append(klaviyo_bis);
      $(".add__to__cart__section").append(wrapper);
    }
  });

}, false);